import { FormattedMessage, useIntl } from 'react-intl';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSuperState } from 'hooks';
import { useApp } from 'app/context';
import { ServicesApi } from 'apis';

const LANGUAGES = [
    { label: 'English', locale: 'en-US' },
    { label: 'Español', locale: 'es-MX' },
    { label: 'Português', locale: 'pt-BR' },
    { label: '简体中文', locale: 'zh-CN' }
];

// const openFeedbackWindow = () => {

//     const currentPath = encodeURIComponent(window.location.href);
//     const url = `/feedback?feedbackLocation=${currentPath}`;
//     const width = 900;
//     const height = 700;
//     const left = (window.screen.width / 2) - (width / 2);
//     const top = (window.screen.height / 2) - (height / 2);

//     window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`);

// };

export const AccountMenu = () => {

    const { cultureTag, currentUser, highestRole, logOut } = useApp();
    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        isLanguageOpen: false,
        isLoggingOut: false
    });
    const { isLanguageOpen, isLoggingOut } = state;

    const isSysAdmin = highestRole?.id === 1;
    const hasAuthoringAccount = currentUser?.hasAuthoringAccount ?? false;
    const hasStudentAccount = currentUser?.hasStudentAccount ?? false;

    const handleLanguageSelect = async (locale: string) => {

        try {

            await ServicesApi.setCulture(locale);
            window.location.reload();

        } catch (e){

            console.error('Failed to set culture:', e);

        }

    };

    const handleLoginAsTC = async () => {

        try {

            await ServicesApi.loginAsGMetrixTC();
            window.location.href = '/';

        } catch (e){

            console.error('Failed to login as GMetrix TC:', e);

        }

    };

    const handleLoginAsStudent = async () => {

        try {

            const bridgeUrl = await ServicesApi.getStudentLoginBridgeUrl();
            window.open(bridgeUrl, '_blank');

        } catch (e){

            console.error('Failed to login as student:', e);

        }

    };

    const handleLoginAsAuthor = async () => {

        try {

            const bridgeUrl = await ServicesApi.getAuthorLoginBridgeUrl();
            window.open(bridgeUrl, '_blank');

        } catch (e){

            console.error('Failed to login as author:', e);

        }

    };

    const handleLanguageToggle = e => {

        e.preventDefault();
        e.stopPropagation();
        setState({ isLanguageOpen: !state.isLanguageOpen });

    };

    return (
        <Dropdown align="end" className={'account-menu'}>

            <Dropdown.Toggle aria-label={currentUser?.fullName ?? currentUser?.userName ?? formatMessage({ id: 'account_menu.03c37597', defaultMessage: 'Account menu' })} className={'small'} id="account-menu-toggle" variant="secondary">
                <span className="d-none d-sm-inline me-2">
                    {currentUser?.fullName ?? currentUser?.userName}
                </span>
                <i aria-hidden="true" className="fa-solid fa-user d-sm-none" />
            </Dropdown.Toggle>

            <Dropdown.Menu>

                <Dropdown.Item as={Link} to={'/account'}>
                    <FormattedMessage defaultMessage="My Account" id="my_account.e83608c1" />
                </Dropdown.Item>

                {/* Language submenu */}
                <Dropdown.Item
                    as="button"
                    className="d-flex justify-content-between align-items-center"
                    onClick={handleLanguageToggle}
                >
                    <FormattedMessage defaultMessage="Language" id="language.bc205d83" />
                    <i
                        style={{
                            transform: isLanguageOpen ? 'rotate(180deg)' : 'rotate(0)',
                            transition: 'transform 200ms'
                        }}
                        aria-hidden="true"
                        className="fa-solid fa-angle-down ms-2"
                    />
                </Dropdown.Item>

                {isLanguageOpen && LANGUAGES.map(lang => {

                    const isSelected = cultureTag === lang.locale;

                    return (
                        <Dropdown.Item
                            active={isSelected}
                            key={lang.locale}
                            onClick={() => handleLanguageSelect(lang.locale)}
                            style={{ paddingLeft: 30 }}
                        >
                            {lang.label}
                        </Dropdown.Item>
                    );

                })}

                <Dropdown.Divider />

                {isSysAdmin && (
                    <Dropdown.Item onClick={handleLoginAsTC}>
                        <FormattedMessage defaultMessage="Login As GMetrix TC" id="login_as_gmetrix_tc.5cc39966" />
                    </Dropdown.Item>
                )}
                {(hasStudentAccount || isSysAdmin) && (
                    <Dropdown.Item onClick={handleLoginAsStudent}>
                        <FormattedMessage defaultMessage="Login As Student" id="login_as_student.ab8d7ae0" />
                    </Dropdown.Item>
                )}
                {hasAuthoringAccount && (
                    <Dropdown.Item onClick={handleLoginAsAuthor}>
                        <FormattedMessage defaultMessage="Login As Author" id="login_as_author.822f4e18" />
                    </Dropdown.Item>
                )}
                {(hasStudentAccount || isSysAdmin || hasAuthoringAccount) && (
                    <Dropdown.Divider />
                )}

                {/*
                    This feature is temporarily disabled, but the code is left here for future reference.
                    <Dropdown.Item onClick={openFeedbackWindow}>
                    Submit Feedback
                    </Dropdown.Item>
                    <Dropdown.Divider />    
                */}

                <Dropdown.Item disabled={isLoggingOut} onClick={logOut}>
                    <FormattedMessage defaultMessage="Log Out" id="log_out.3bf9f06f" />
                </Dropdown.Item>

            </Dropdown.Menu>

        </Dropdown>
    );

};
